<template>
  <div>
    <Head title="Inventory" />
      <!--<button  v-if="auth.user.role == 'ADMIN'" class="btn button px-5 py-2 m-5" @click="idays = 11">11-day (~)</button>
      <button  v-if="auth.user.role == 'ADMIN'" class="btn button px-5 py-2 m-5" @click="idays = 30">30-day (SLOW)</button>
      <button  v-if="auth.user.role == 'ADMIN'" class="btn button px-5 py-2 m-5" @click="idays = 60">60-day (SLOWER)</button>-->
    <h1 class="mb-8 text-3xl font-bold">Inventory</h1>  
    <div v-for="(purchaseorder) in this.invordersSelector">
              <button v-if="(purchaseorder.ordertype !== 'zLUMBER' && purchaseorder.products)" :class="'btn button p2- po-loader po-loader-' + purchaseorder.id" @click="this.filterordersPicked(purchaseorder.id);">
                Load PO #{{ purchaseorder.id }} [{{ purchaseorder.ordertype }}] {{ moment(purchaseorder.orderdate).format('MM/DD/YYYY') }}
              </button>
      </div>
    
    <div v-for="(purchaseorder) in this.invorders">
      <template v-if='(purchaseorder.ordertype !== "zLUMBER" && purchaseorder.products)'>
          <table :id="'inventory-grid-table-' + purchaseorder.id" :class="'inventory-grid-table zloading'" v-show='((purchaseorder.ordertype !== 1) && JSON.parse(purchaseorder.products))'>
            <tr class="m-2 po-bold">
              <th colspan="99" class="p2-">PO #{{ purchaseorder.id }} - {{ purchaseorder.ordertype }} - {{ purchaseorder.projected_delivery }}</th>
            </tr>
            <tr class="">
              <th class="pb-2">TxWxL</th>
              <th class="">Item Desc</th><th>PO Qty</th>
              <th class="p-1"><button class="btn-indigo font-bold m-1 p-2" @click="startday = dayDelta(startday,-1*(idays),projectstartday);">&lt;&lt;</button><button class="btn-indigo font-bold m-1 p-2" @click="startday = dayDelta(startday,-1,projectstartday);">&lt;</button></th>
              <th
                v-for="iday in idays"
                v-bind:class='dayheaderClass(startday,iday)'
              >
                <a :href='(getDaylogExist(getDate(startday,iday)) == false ? "/daylogs/create/?p=1&d=" + getDate(startday,iday) : "/daylogs/" + getDaylogExist(getDate(startday,iday)).id + "/edit/")'>
                  {{ getDateHuman(startday,iday) }}
                </a>
              </th>
              <th class="p-1"><button class="btn-indigo font-bold m-1 p-2" @click="startday = dayDelta(startday,1,projectstartday);">&gt;</button><button class="btn-indigo font-bold m-1 p-2" @click="startday = dayDelta(startday,idays,projectstartday);">&gt;&gt;</button></th>
              <th class="p-2">Proj. Net</th>
            </tr>
            <tr v-for="(product, loop) in JSON.parse(purchaseorder.products)" class="inventory-row" v-bind:id="'inventory-row-' + purchaseorder.id + '-' + (loop+1)">
              <td class="px-1 itemsize">{{product.sizet}}<span class="text-xs"> x </span>{{product.sizew}}<span class="text-xs"> x </span>{{product.sizel}}</td>
              <td class="px-1 itemdesc">{{product.itemdesc}}</td>
              <td class="px-1 start-qty" :id='"inv-row-start-" + purchaseorder.id + "-" + (loop+1)'>{{ (product.quantity + "").replace(',','').replace('%','') }}</td>
              <td class="void "></td>
              <!--v-html --- <td class="inventory-delta text-sm" v-for="(iday, idayloop) in idays"></td>-->
              <td class="inventory-delta text-sm loadingsm" v-for="(iday, idayloop) in idays" :id="'inv-delt-' + purchaseorder.id + '-' + (loop+1) + '-' + getDate(startday,iday)"
              :data-calc='[0,getDate(startday,iday),(loop+1),purchaseorder.id]'
              ></td>
              <!--   -->
              <td class="void"></td>
              <td class="p-1 inv-current-total loadingsm" :id='"inv-current-" + purchaseorder.id + "-" + (loop+1)'
              :data-calc="[1,(loop+1),purchaseorder.id,(product.quantity + '').replace(',','').replace('%','')]"
              ></td>
            </tr>
            <br/>
            <br/>
          </table>
      </template>
    </div>
  </div>
   <div id="updatejobsite" @click="filterorders"></div>
</template>
<style>
  .po-bold th {background:#c5e0e7; text-align:left; padding:5px; }
  #inventory-grid-table td { min-width:45px; font-family:monospace, monospace-ui;}
  #inventory-grid-table tr:nth-child(even) { background:#FAFAFE; }
  .itemsize { width:12%; }
  .itemdesc {
    width:18%;
    font-size:12px; 
    font-size: 12px;
    font-weight: bold;
    font-family: "Arial Narrow";
  }
  .void { border-right:1px dashed #CECECE; border-left:1px dashed #CECECE; }
  .inventory-delta { width:initial; }
  .inventory-delta, .start-qty, .inv-current-total {  text-align:right; position:relative; }
  .inventory-delta a { display:inline-block; /* cursor:copy; */ width:100%; height:100%; }
  .inventory-delta:hover a { background:rgb(255, 224, 102); display:inline-block; /* cursor:copy; */ width:100%; height:100%; }
  .inventory-row:hover { background:hsl(49, 95%, 92%) !important; }
  .positive { color: #1c654f; }
  .negative { color: #3c261d; }
  .hasProjection { position:relative; }
  .hasProjection::after {
      width: 0;
      height: 0;
      border-top: 14px solid #46ddff;
      border-left: 14px solid transparent;
      position:absolute;
      content:' ';
      right:0;
      top:0;
      cursor:pointer;
  }
  .projected-value { color:#00a8cd; }
  .received-value { color:#8f7600; }
  .hasNote { position:relative; }
  .hasNote::before {
      width: 0;
      height: 0;
      border-bottom: 14px solid #FFD91E;
      border-right: 14px solid transparent;
      position:absolute;
      content:' ';
      left:0;
      bottom:0;
      cursor:pointer;
  }
  .dayheader {
    font-size:13px;
    border:2px solid transparent;
  }
  .dayheader:hover {
    box-sizing:border-box;
    background:#fff1aa;
    transition:0.1s;
    cursor:pointer;
  }
  .weekend { 
    font-weight:bold;
    color:rgb(174, 174, 174);
  }
  .inv-daylog-day-sum { font-size:12px; width:100%; height:100%; position:absolute; top:0; left:0; text-align:center; }
  .slice { font-size:5px; }
  .hide { display:none !important; opacity:0 !important; pointer-events:none !important; }
  .loadingsm {
    height:5px;
    opacity:0.1;
    pointer-events:none;
    background:#777777;
  }
  .loading {
    height:250px;
    opacity:0.3;
    pointer-events:none;
		background: url('data:image/svg+xml;base64,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') 50% 50% no-repeat rgb(249,249,249);
  }
  .button { border:1px solid #333; padding:4px 8px; }
  .hide {display:none !important;}
</style>
<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import moment from 'moment'
import { isIntegerKey } from '@vue/shared';

export default {
  mounted() {

    this.filterorders()
    var bc = this.bigCalc;
    window.setInterval(function() { bc(); },10);

    this.worker = new Worker(new URL('./getInventoryDeltaString.js', import.meta.url), null /* opts */);
    this.worker.addEventListener("message", function msgFromWorker(msg) {
      const bufTransferredBackFromWorker = msg.data;
      //console.log(bufTransferredBackFromWorker);
    });
    this.worker2 = new Worker(new URL('./getInventoryCurrentTotalWorker.js', import.meta.url), null);
    this.worker2.addEventListener("message", function msgFromWorker(msg) {
        const bufTransferredBackFromWorker = msg.data;
        //console.log(bufTransferredBackFromWorker);
      });
  },
  components: {
    Head,
    Link,
    Icon,
  },
  layout: Layout,
  props: {
    jobsites: Object,
    purchaseorders: Object,
    orders: Object,
    daylogs: Object,
    auth: Object,
  },
  data() {
    return {
      idays: 11,
      startday: moment().format('YYYYMMDD'), //"20230301",
      projectstartday: "20230101",
      moment: moment,
      invorders: [],
      invordersSelector: [],
      filteredjobsites: this.authjobsites(),
      inventoryOn: [],
      ordersdata: JSON.stringify(this.orders),
      daylogsdata: JSON.stringify(this.daylogs),
      //jobsite: this.purchaseorders.data[0].jobsite_id,
      worker: null,
      worker2: null,
      bigCalcTodo: [],
    }
  },
  methods: {
    bigCalc() {
      try {
        var a = this.getInventoryDeltaString;
        var b = this.getInventoryCurrentTotal;
        var firstfind = document.querySelectorAll('.loadingsm')[0];
        var v = firstfind.getAttribute('data-calc').split(',');

        if (v[0] == 0) {
          a(v[1],v[2],v[3]);
        } else if (v[0] == 1) {
          b(v[1],v[2],v[3]);
          console.log(v);
        }
        firstfind.classList.remove('loadingsm');
      } catch(e) { }
    },
    pickjobsite: (jid) => {
      document.cookie = 'jobsite=' + jid +';path=/;';
      try { window.setTimeout(function() { document.querySelector('#mainmenu .text-white').parentElement.click(); },1);
      } catch(e) { console.error(e); }
    },
    authjobsites() {
      var jsa = JSON.parse(this.auth.user.jobsiteaccess);
      var jobsitesyes = [];
      this.jobsites.data.forEach((js) => {
        if (jsa[js.id] == 1) {
          jobsitesyes.push(js);
        }
      });
      return jobsitesyes;
    },
    filterorders() {
      var o = [];
      try { var js = parseInt(document.querySelector('#jobsiteselector').value);
        this.purchaseorders.data.forEach((purchaseorder) => {
          if (purchaseorder.jobsite_id == js) {
            o.push(purchaseorder);
          }
        });
        this.invordersSelector = o;
      } catch(e) { }
    },
    filterordersPicked(poid) {
      //document.querySelectorAll('.po-loader-' + poid)[0].classList.add('hide');
      document.querySelectorAll('.po-loader').forEach((v) => { v.classList.add('hide'); });
      var o = [];
      try { var js = parseInt(document.querySelector('#jobsiteselector').value);
        this.purchaseorders.data.forEach((purchaseorder) => {
          if (purchaseorder.id == poid) {
            o.push(purchaseorder);
          }
        });
        this.invorders = o;
        //window.setTimeout(function() { },1);
      } catch(e) { }
    },
    getDate: (startday,iday) => {
      return moment(startday, "YYYYMMDD").add(iday-1, 'days').format('YYYYMMDD');
    },
    getDateHuman: (startday,iday) => {
      return moment(startday, "YYYYMMDD").add(iday-1, 'days').format('MMM Do');
    },
    dayDelta: (startday,D,projectstartday) => {
      //document.querySelectorAll('#inventory-grid-table').forEach((gt) => { gt.classList.add('loading'); });
      var newdate;
      if (D > 0) { newdate = moment(startday, "YYYYMMDD").add(D, 'days').format('YYYYMMDD'); }
      if (D < 0) { newdate = moment(startday, "YYYYMMDD").subtract((D*-1), 'days').format('YYYYMMDD'); }
      if (projectstartday > newdate) { newdate = projectstartday; }
      document.querySelectorAll('.inventory-delta, .inv-current-total').forEach((v,k) => {
        v.classList.add('loadingsm');
      });
      return newdate;
    },
    getInventoryCurrentTotalWorker(productrow,purchaseorderid,qty) {

      var opts = {
        'productrow': productrow,
        'purchaseorderid': purchaseorderid,
        'qty': qty,
        'gorders': this.ordersdata,
      };

      this.worker2.postMessage(opts);
    },
    getInventoryDeltaStringWorker(dday,productrow,projectstartday,purchaseorderid) {
          
      var islog = false;

      Object.values(this.daylogsdata).forEach((daylog) => {
        var localday = moment(daylog.reportday, 'YYYY-MM-DD').utc().local().format('YYYYMMDD');
        //var localday = daylog.reportday.replace('-','').replace('-','').replace('-','');
          if (localday == dday) { islog = daylog; }
      });
      var opts = {
          'productrow': productrow,
          'purchaseorderid': purchaseorderid,
          'dday': dday,
          'gorders': JSON.parse(this.ordersdata),
          'daylogs': JSON.parse(this.daylogsdata),
          'projectstartday': projectstartday,
          'purchaseorderid': purchaseorderid,
          'islog': islog,
        };
        
        this.worker.postMessage(opts);
   
    },
    getInventoryDeltaString(dday,productrow,purchaseorderid) {

      var ret = "";
      var ret2 = "";
      var islog = false;
      this.daylogs.data.forEach((daylog) => {
        //var localday = moment(daylog.reportday, 'YYYY-MM-DD').utc().local().format('YYYYMMDD');
        var localday = daylog.reportday.replace('-','').replace('-','').replace('-','');
        if (localday == dday) { islog = daylog; }
      });

      if (islog !== false) {
          try {
            var orderupds = JSON.parse(islog.orderupdates);
            ret = (orderupds ? orderupds[purchaseorderid][productrow-1] : '');
          } catch(e) { }
      }
      var gorders = JSON.parse(this.ordersdata);
      var gorders2 = [];

      Object.values(gorders).forEach((order,k) => {
        if (order.purchaseorder_id == purchaseorderid) {
          if (typeof(order.products) !== 'undefined') {
            gorders2.push(order);
          }
        } else {
        }
      });

      gorders2.forEach(function(order,k) {
        var op = JSON.parse(order.products);
        Object.values(op).forEach((opr,productkey) => {
          if (opr.qty_ordered && opr.projected_delivery) {
            //var projectedtest = moment(opr.projected_delivery, 'YYYY-MM-DD').utc().local().format('YYYYMMDD');
            var projectedtest = opr.projected_delivery.replace('-','').replace('-','').replace('-','');
            if (projectedtest == dday) {        
              if (productrow == productkey+1) {
                ret2 = opr.qty_ordered;
              }
            } else { }
          } else { }
        })
      });


      if (islog !== false) {
          try {
            var orderupds = JSON.parse((islog.orderupdates)).ordersAdd;
            ret2 = orderupds[purchaseorderid][productrow-1];
          } catch(e) {  }
      }

      if (ret == null) { ret = ''; }
      if (ret2 == null) { ret2 = ''; }
      
      //return "<span class='inv-daylog-day-sum'><span class='received-value'>" + ret + "</span>&nbsp;<span class='slice'>/</span>&nbsp;<span class='projected-value'>" + ret2 + "</span></span>";
      var a = "<span class='inv-daylog-day-sum'><span class='received-value'>" + ret + "</span>&nbsp;<span class='slice'>/</span>&nbsp;<span class='projected-value'>" + ret2 + "</span></span>";
      document.querySelector('#inv-delt-' + purchaseorderid + '-' + productrow + '-' + dday).innerHTML = a;
      
    },
    addInventoryDelta: (iday,productrow) => {
      //console.log(iday);
      //console.log(productrow);
    },
    getInventoryCurrentTotal(productrow,purchaseorderid,qty) {
      //var gorders = JSON.parse(document.querySelector('#ordersdata').getAttribute('data'));
      var gorders = JSON.parse(this.ordersdata);
      //console.log(JSON.parse(gorders));
      Object.values(gorders).forEach((order,k) => {
        try { 
          if (order.purchaseorder_id.toString() == purchaseorderid) {
            if (order.products) {
                var op = JSON.parse(order.products);
                op.forEach((opr,productkey) => { 
                  if (opr.qty_ordered && opr.projected_delivery) {
                    //var projectedtest = moment(opr.projected_delivery, 'YYYY-MM-DD').utc().local().format('YYYYMMDD');
                      if (productrow == productkey+1) {
                        qty -= opr.qty_ordered;
                      }
                    } else { }
                })
            }
          }
        } catch(e) { console.warn(e); }
      });
      //return qty;
      document.querySelector('#inv-current-' + purchaseorderid + '-' + productrow).innerHTML = qty;
      
      /*
      var delta = 0;
      this.daylogs.data.forEach((daylog) => {
        if (daylog !== false) {
          if (daylog.orderupdates !== false) {
            var orderupds = JSON.parse(daylog.orderupdates);
            if ((orderupds !== null) && (orderupds.orders !== null)) {
              try {
                var orderindex =  parseInt(orderid)+1;
                var productindex = parseInt(productrow)-1;
                var upval = parseInt((orderupds.orders[orderindex][productindex] + "").replace(',',''));
                delta += parseInt((upval + "").replace(',',''));
                if (isNaN(delta)) { delta = 0; }
              } catch(e) { }
            }
          }
        }
      });

      var delta2 = 0;
      this.daylogs.data.forEach((daylog) => {
        if (daylog !== false) {
          if (daylog.orderupdates !== false) {
            var orderupds2 = JSON.parse(daylog.orderupdates);
            if ((orderupds2 !== null) && (orderupds2.ordersAdd !== null)) {
              try {
                var orderindex2 =  parseInt(orderid)+1;
                var productindex2 = parseInt(productrow)-1;
                var orderstringdelta2 = orderupds2.ordersAdd[orderindex2][productindex2];
                var upval2 = parseInt((orderstringdelta2 + "").replace(',',''))
                delta2 += parseInt((upval2 + "").replace(',',''));
                if (isNaN(delta2)) { delta2 = 0; }
              } catch(e) { }
            }
          }
        }
      });
      var total = parseInt(delta2) - parseInt(delta);
      return total;
      */
    },
    getDaylogExist(iday) {
      var islog = false;
      this.daylogs.data.forEach((daylog) => {
        //var localday = moment(daylog.reportday, 'YYYY-MM-DD').utc().local().format('YYYYMMDD');
        var localday = daylog.reportday.replace('-','').replace('-','').replace('-','');
        if (localday == iday) { islog = daylog; }
      });
      return islog;
    },
    getOrderProjectionExist(checkday) {
      var islog = false;
      //(moment(opr.projected_delivery, 'YYYY-MM-DDT').utc().local().format('YYYYMMDD') == iday)
      //var gorders = JSON.parse(document.querySelector('#ordersdata').getAttribute('data'));
      var gorders = this.ordersdata;
      Object.values(gorders).forEach((order) => {
        try {
        if (order.products) {
          if (order.products.length > 0) {
              var op = JSON.parse(order.products);
              op.forEach((opr) => {
                if (opr.qty_ordered && opr.projected_delivery) {
                  //var projectedtest = moment(opr.projected_delivery, 'YYYY-MM-DD').utc().local().format('YYYYMMDD');
                  var projectedtest = opr.projected_delivery.replace('-','').replace('-','').replace('-','');
                  if (projectedtest == checkday) {               
                    islog = true;
                  } else { }
                } else { }
              })
          }
        }
            } catch(e) { }
      });
      return islog;
    },
    getDaylogId: (iday,startday) => {
      return 1;
    },
    dayheaderClass(startday,iday) {
      var classes = "dayheader ";
      if (this.getDaylogExist(this.getDate(startday,iday)) !== false ) { classes += "hasNote "; }
      if (this.getOrderProjectionExist(this.getDate(startday,iday)) !== false ) { classes += "hasProjection "; }
      if (moment(this.getDate(startday,iday),'YYYYMMDD').day() == 6) { classes +="weekend saturday "; }
      if (moment(this.getDate(startday,iday),'YYYYMMDD').day() == 0) { classes +="weekend sunday "; }
      return classes;
    }
  },
}
</script>